const paounits = [
  "GCU",
  "Economic Crimes",
  "Violent or Economic Crimes - MRJC",
  "Domestic Violence",
  "Domestic Violence - MRJC",
  "Special Operations",
  "Special Assault",
  "Special Assault - MRJC",
  "Homicide and Violent Crimes",
  "Crime Strategies",
  "Juvenile",
  "MDOP",
  "Other"
];
export default paounits;
